import { ProtectedRoute as SharedProtectedRoute } from '@mdvip/shared/system/ProtectedRoute';
import type { Action, Subject } from '@mdvip/shared/types/ability';
import type { ReactNode } from 'react';

import { useAuth } from '@/contexts/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  /** Optional ability gate, forwarded to the shared route guard — see its own doc comment. */
  can?: [Action, Subject];
}

export function ProtectedRoute({ children, can }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  return (
    <SharedProtectedRoute isAuthenticated={isAuthenticated} isLoading={isLoading} portalType="providers" can={can}>
      {children}
    </SharedProtectedRoute>
  );
}
